export const TOGGLE_ENTRY_STRATEGY = 'TOGGLE_ENTRY_STRATEGY';
export const TOGGLE_ENTRY_STRATEGY_SUCCESS = 'TOGGLE_ENTRY_STRATEGY_SUCCESS';
export const TOGGLE_ENTRY_STRATEGY_ERROR = 'TOGGLE_ENTRY_STRATEGY_ERROR';
